import moment from 'moment';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ShippingGallery from '../../Modals/shippingGallery';
import { APPROVAL_STATUS } from '../../utils/enums';

type props = {
  type: any;
  data: any;
};

const PersonalInformation = ({ type, data }: props) => {
  const navigate = useNavigate();

  const [openModal4, setOpenModal4] = useState(false);
  const handleCloseModal4 = () => {
    setOpenModal4(false);
  };

  return (
    <>
      <div className="profileInfo_head">
        <h2>Personal Detail</h2>
        {/* <Button
          className="btn btn_secondary"
          onClick={() => navigate(`/edit-profile-detail/${type}/${data?._id}`)}
        >
          Edit Details
        </Button> */}
      </div>

      <div className="profileInfo_list">
        <ul className="text_info gap_p">
          {/* <li className="w_50">
            <strong>User Id</strong>
            <span>#CR1987876</span>
          </li> */}
          <li className="w_50">
            <strong>User Type</strong>
            <span>
              {type === 'individual' ? 'Individual' : type === 'dealer' ? 'Dealer' : 'Store'}
            </span>
          </li>
          <li className="w_50">
            <strong>Name</strong>
            <span>{data?.name || '-'}</span>
          </li>
          <li className="w_50">
            <strong>E-mail</strong>
            <span>{data?.email || '-'}</span>
          </li>
          <li className="w_50">
            <strong>Phone</strong>
            <span>
              {data?.dialCode} {data?.phoneNo || '-'}
            </span>
          </li>
          {type === 'dealer' || type === 'store' ? (
            <>
              <li className="w_50">
                <strong>Store Name</strong>
                <span>{data?.store?.storeName || '-'}</span>
              </li>
              {data?.store?.openingTime ? (
                <li className="w_50">
                  <strong>Store Opening Time</strong>
                  <span>{moment(data?.store?.openingTIme).format('LT')}</span>
                </li>
              ) : null}
              {data?.store?.closingTime ? (
                <li className="w_50">
                  <strong>Store Closing Time</strong>
                  <span>{moment(data?.store?.closingTime).format('LT')}</span>
                </li>
              ) : null}
            </>
          ) : null}
          <li className="w_50">
            <strong>Address</strong>
            <span>{data?.addressObject?.address || '-'}</span>
          </li>
          <li className="w_50">
            <strong>City</strong>
            <span>{data?.addressObject?.city || '-'}</span>
          </li>
          <li className="w_50">
            <strong>Pin Code</strong>
            <span>{data?.addressObject?.pincode || '-'}</span>
          </li>
          {type === 'individual' ? null : (
            <li className="w_50">
              <strong>Approval Status</strong>
              <span>
                {data?.status === APPROVAL_STATUS.APPROVED
                  ? 'Approved'
                  : data?.status === APPROVAL_STATUS.PENDING
                    ? 'Pending'
                    : 'Rejected'}
              </span>
            </li>
          )}
        </ul>
        <ul className="text_info gap_p" style={{ marginTop: '10px' }}>
          {type === 'dealer' || type === 'store' ? (
            <>
              <li style={{ flexDirection: 'column' }}>
                <strong>Bio</strong>
                <span>{data?.Bio || '-'}</span>
              </li>
            </>
          ) : null}
        </ul>
        <div className="gap_p">
          <div className="w_50">
            <h3>Bank Account Details</h3>
            <ul className="text_info gap_p">
              <li>
                <strong>Bank Name</strong>
                <span>{data?.bankDetails?.bankName || '-'}</span>
              </li>
              <li>
                <strong>Account Holder Name</strong>
                <span>{data?.bankDetails?.accountHolederName || '-'}</span>
              </li>
              <li>
                <strong>Branch Name</strong>
                <span>{data?.bankDetails?.branchName || '-'}</span>
              </li>
              <li>
                <strong>Bank Code</strong>
                <span>{data?.bankDetails?.bankCode || '-'}</span>
              </li>
            </ul>
          </div>

          {/* <div className="w_50">
            <h3>Payment Procedure Information _Upon Delivery (100%)</h3>
            <ul className="text_info gap_p">
              <li>
                <strong>Currency</strong>
                <span>Currey of departure</span>
              </li>
              <li>
                <strong>Bank Name</strong>
                <span>Al Rajhi Bank</span>
              </li>
              <li>
                <strong>Account Holder Name</strong>
                <span>Naief Osman</span>
              </li>
              <li>
                <strong>Bank Name</strong>
                <span>1523-4628-4297-9953</span>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
      {/* 
      <div className="shipping_img">
        <h3>Shipping Pictures</h3>
        <ul>
          <li>
            <figure onClick={() => setOpenModal4(true)}>
              <img src="/static/images/shipping_01.jpg" alt="Shipping" />
            </figure>
          </li>
          <li>
            <figure onClick={() => setOpenModal4(true)}>
              <img src="/static/images/shipping_02.jpg" alt="Shipping" />
            </figure>
          </li>
          <li>
            <figure onClick={() => setOpenModal4(true)}>
              <img src="/static/images/shipping_03.jpg" alt="Shipping" />
            </figure>
          </li>
          <li>
            <figure onClick={() => setOpenModal4(true)}>
              <img src="/static/images/shipping_04.jpg" alt="Shipping" />
            </figure>
          </li>
        </ul>

        <TableContainer className="table_container">
          <Box className="heading"></Box>
          <Table className="v2" aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Shipping Customers</TableCell>
                <TableCell>Customer comment</TableCell>
                <TableCell>Delivery Home</TableCell>
                <TableCell>Packaging service</TableCell>
                <TableCell>Shipping</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Shipping cost</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>
                  <div className="user_block">
                    <figure>
                      <img src="/static/images/user_attachment.jpg" alt="" />
                    </figure>
                    <p>
                      <b>Riyadh</b> +9203024595467
                    </p>
                  </div>
                </TableCell>
                <TableCell>
                  <p className="view_link" onClick={() => setOpenModal3(true)}>
                    Comment{" "}
                    <img src="/static/images/external_icon.svg" alt="Icon" />
                  </p>
                </TableCell>
                <TableCell>No</TableCell>
                <TableCell>Yes</TableCell>
                <TableCell>
                  <figure className="icon_text">
                    <img src="/static/images/briefcase_icon.svg" alt="Icon" />
                    <figcaption>Suit Case</figcaption>
                  </figure>
                </TableCell>
                <TableCell>25</TableCell>
                <TableCell>40$</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>
                  <div className="user_block">
                    <figure>
                      <img src="/static/images/user_attachment.jpg" alt="" />
                    </figure>
                    <p>
                      <b>Riyadh</b> +9203024595467
                    </p>
                  </div>
                </TableCell>
                <TableCell>
                  <p className="view_link" onClick={() => setOpenModal3(true)}>
                    Comment{" "}
                    <img src="/static/images/external_icon.svg" alt="Icon" />
                  </p>
                </TableCell>
                <TableCell>No</TableCell>
                <TableCell>Yes</TableCell>
                <TableCell>
                  <figure className="icon_text">
                    <img src="/static/images/briefcase_icon.svg" alt="Icon" />
                    <figcaption>Suit Case</figcaption>
                  </figure>
                </TableCell>
                <TableCell>25</TableCell>
                <TableCell>40$</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div> */}

      {/* <PassportResidenceModal
        open={openModal1}
        onClose={handleCloseModal1}
        setOpen={setOpenModal1}
      />
      <VehicleRegistrationModal
        open={openModal2}
        onClose={handleCloseModal2}
        setOpen={setOpenModal2}
      />
      <ViewComment
        open={openModal3}
        onClose={handleCloseModal3}
        setOpen={setOpenModal3}
      /> */}
      <ShippingGallery open={openModal4} onClose={handleCloseModal4} setOpen={setOpenModal4} />
    </>
  );
};

export default PersonalInformation;
